const language = {
    'pt':
    {
        or: 'ou',
        deadline: 'Prazo',
        atrasado: 'atrasado',
        dia: 'dia',
        ///LIST///
        arquivo: 'Selecionar Arquivos',
        arquivos: 'Arquivos Submetidos',
        close: 'Fechar',
        dark_mode: 'modo escuro',
        tarefa_prioridade: 'Prioridade',
        tarefa_estado: 'Estado',
        tarefa_departamento: 'Departamento',
        tarefa_grupo: 'Grupo',
        tarefa_resp: 'Responsáveis',
        concluida: 'Concluída',
        task_number: 'Nº',
        view: 'Ver',
        edit: 'Editar',
        delete: 'Apagar',
        detalhes: 'Detalhes para o Responsável',
        detalhes_placeholder: 'Digite os detalhes para o responsável...',
        tarefa: 'Tarefa',
        home: 'Home',
        tarefa_list: 'Lista de tarefas',
        tarefa_filtro_todas: 'Ver Todas',
        tarefa_filtro_concluidos: 'Concluídos',
        tarefa_filtro_canceladas: 'Canceladas',
        tarefa_filtro_nao_concluidos: 'Por Concluir',
        tarefa_por_expirar: 'Por Expirar',
        tarefa_revisao: 'Em Revisão',
        tarefa_expirados: 'Expirados',
        add_new_tarefa: 'Nova tarefa',
        no_results: 'Sem resultados',
        tarefa_monitor: 'Monitor',
        delete_task: 'Apagar tarefa',
        delete_success: 'Apagado com sucesso',
        delete_error: 'Erro ao apagar tarefa',
        ////// REGIST ////
        insert_task: 'Inserir nova tarefa',
        tarefa_data: 'Dados das Tarefas',
        tarefa_acao_placeholder: 'Insira o título da tarefa',
        tarefa_empresa: 'Empresa',
        tarefa_empresa_placeholder: 'Escolha a empresa',
        estado1: 'A iniciar',
        estado2: 'Em Execução',
        estado3: 'Em Verificação ',
        estado4: 'Concluído',
        estado5: 'Cancelado',
        prioridade_normal: 'Normal',
        prioridade_urgente: 'Urgente',
        prioridade_critico: 'Crítico',
        tarefa_prioridade_placeholder: 'Prioridade da tarefa',
        tarefa_estado_placeholder: 'Estado da tarefa',
        departamento_responsavel: 'Departamento responsável',
        grupo_responsavel: 'Grupo responsável',
        resp_grupo: 'Responsável do grupo',
        tarefa_departamento_placeholder: 'Referente departamento',
        tarefa_grupo_placeholder: 'Referente Grupo',
        tarefa_respm: 'Responsáveis',
        tarefa_respm_placeholder: 'Responsáveis',
        description: 'Descrição',
        resumo: 'Resumo',
        solucao: 'Solução',
        validar_tarefa: 'Validar a Tarefa?',
        confirmar_tarefa: 'Confirmar a Tarefa?',
        submeter_tarefa: 'Submeter a Tarefa?',
        cancel: 'Cancelar', back: 'Voltar',
        delete: 'Apagar',
        save: 'Guardar',
        edit: 'Editar',
        edit_text: 'Deseja editar a Tarefa?',
        edit_confirm: 'Confirmar',
        edit_cancel: 'Cancelar',
        insert_title: 'Inserir tarefa',
        insert_text: 'Quer inserir esta tarefa?',
        insert_confirm: 'Confirmar',
        insert_sucess: 'Registo inserido com sucesso!',
        language: 'Lingua',

        insert_error: 'Erro a inserir registo',
        edit_error: 'Problema ao actualizar registo!',
        loading: 'Carregando',
        tarefa_data: 'Data Ínicio',
        data_inicio: 'Data Ínicio',
        data_limite: 'Data Limite',
        validar_sucesso: 'Validado',
        relatorio: 'Relatório',
        validar: 'Validar',
        naovalidar: 'Não Validar',

        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        monitor: 'Monitor',
        monitor_placeholder: 'Selecione o monitor',
        insert_cancel: 'Cancelar',

        /// VIEW///
        titulo_tarefa: 'Título da tarefa',
        codigo_tarefa: 'Código da tarefa',
        tarefa_tempo_expiracao: 'Tempo expiração tarefa',
        tarefa_data_solucao: 'Data Solução',
        exportar_relatorio: 'Exportar Relatório',
        imprimir_relatorio: 'Imprimir Relatório',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_title: 'Aviso!',
        observations: 'Observações',
        no_priority: 'Sem Prioridade',
        anexos: 'Anexos',
        no_anexos: 'Nenhum anexo disponível',
        nota: 'Nota',
        n_tarefa: 'Nº da Tarefa',
        view:'Ver',

        //Delete
        delete_cfp: 'Eliminar Tarefa',
        delete_cfp_text: 'Tem a certeza que quer eliminar a Tarefa?',
        delete_cfp_confirm: 'Continuar',
        delete_cfp_cancel: 'Cancelar',
        filter_placeholder: 'Procurar'
    },
    'en':
    {
        view:'view',
        or: 'or',
        n_tarefa: 'Task number',
        dia: 'day',
        atrasado: 'late',
        arquivo: 'Select Files',
        arquivos: 'Selected Files',
        anexos: 'Attachments',
        no_anexos: 'No Attachments',
        deadline: 'Deadline',
        //LIST
        observations: 'Observations',
        delete_error: 'Delete error',
        delete_success: 'Successful deleted',
        delete_task: 'Delete task',
        tarefa_monitor: 'Monitor',
        tarefa_prioridade: 'Priority',
        tarefa_estado: 'State',
        tarefa_departamento: 'Department',
        tarefa_grupo: 'Group',
        tarefa_resp: 'Responsible',
        concluida: 'Completed',
        task_number: 'Nº',
        view: 'View',
        edit: 'Edit',
        delete: 'Delete',
        detalhes: 'Details for Responsibles',
        detalhes_placeholder: 'Enter the details for responsibles...',
        tarefa: 'Task',
        home: 'Home',
        tarefa_list: 'Task List',
        tarefa_filtro_todas: 'See All',
        tarefa_filtro_nao_concluidos: 'To Complete',
        tarefa_filtro_concluidos: 'Completed',
        tarefa_filtro_canceladas: 'Canceled',
        tarefa_por_expirar: 'To Expire',
        tarefa_revisao: 'In Review',
        tarefa_expirados: 'Expired',
        add_new_tarefa: 'New Task',
        no_results: 'No results',

        ////// REGIST ////
        insert_task: 'Insert new task',
        tarefa_data: 'Task Data',
        tarefa_acao_placeholder: 'Enter task title',
        tarefa_empresa: 'Company',
        tarefa_empresa_placeholder: 'Choose the company',
        estado1: 'To Start',
        estado2: 'In Progress',
        estado3: 'Under Review',
        estado4: 'Completed',
        estado5: 'Canceled',
        prioridade_normal: 'Normal',
        prioridade_urgente: 'Urgent',
        prioridade_critico: 'Critical',
        tarefa_prioridade_placeholder: 'Task Priority',
        tarefa_estado_placeholder: 'Task State',
        departamento_responsavel: 'Responsible Department',
        grupo_responsavel: 'Responsible Group',
        resp_grupo: 'Group Responsible',
        tarefa_departamento_placeholder: 'Related department',
        tarefa_grupo_placeholder: 'Related Group',
        tarefa_respm: 'Responsible',
        tarefa_respm_placeholder: 'Responsible',
        description: 'Description',
        resumo: 'Overview',
        solucao: 'Solution',
        validar_tarefa: 'Approve the task?',
        confirmar_tarefa: 'Confirm the task?',
        submeter_tarefa: 'Submit the task?',
        cancel: 'Cancel',
        delete: 'Delete',
        save: 'Save',
        edit: 'Edit',
        edit_text: 'Do you want to edit this Task?',
        edit_confirm: 'Confirm',
        edit_cancel: 'Cancel',
        insert_title: 'Insert new task',
        insert_text: 'Want to insert new task ?',
        insert_cancel: 'Cancel',
        insert_confirm: 'Confirm',
        insert_error: 'Error inserting',
        edit_error: 'Error editing task',
        loading: 'Loading',
        tarefa_data: 'Start Date',
        data_inicio: 'Start Date',
        data_limite: 'Deadline',
        monitor: 'Monitor',
        monitor_placeholder: 'Select the monitor',
        validar: 'Validate',
        naovalidar: 'Don´t Validate',
        /// VIEW ///
        titulo_tarefa: 'Task Title',
        codigo_tarefa: 'Task Code',
        tarefa_tempo_expiracao: 'Task Expiration Time',
        tarefa_data_solucao: 'Solution Date',
        exportar_relatorio: 'Export Report',
        imprimir_relatorio: 'Print Report',
        relatorio: 'Report',
        back: 'Back',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        no_priority: 'No Priority',
        nota: 'Grade',

        delete_cfp: 'Delete Task',
        delete_cfp_text: 'Are you sure you want to delete the Task?',
        delete_cfp_confirm: 'Continue',
        delete_cfp_cancel: 'Cancel',
        back: 'Back',
        filter_placeholder: 'Search',
    },
    'es':
    {
        ///LIST///
        tarefa_prioridade: 'Prioridad',
        tarefa_estado: 'Estado',
        tarefa_departamento: 'Departamento',
        tarefa_resp: 'Responsables',
        concluida: 'Completada',
        task_number: 'Nº',
        view: 'Ver',
        edit: 'Editar',
        delete: 'Borrar',
        tarefa: 'Tarea',
        home: 'Inicio',
        tarefa_list: 'Lista de tareas',
        tarefa_filtro_nao_concluidos: 'Filtrar No Completadas',
        filtro_concluidos: 'Filtrar Completadas',
        tarefa_por_expirar: 'Filtrar Por Vencer',
        tarefa_expirados: 'Filtrar Vencidas',
        add_new_tarefa: 'Nueva tarea',
        no_results: 'Sin resultados',
        tarefa_monitor: 'Monitor',
        delete_task: 'Borrar tarea',
        delete_success: 'Borrada con éxito',
        delete_error: 'Error al borrar tarea',

        ////// REGIST ////
        insert_task: 'Insertar nueva tarea',
        tarefa_data: 'Datos de la Tarea',
        tarefa_acao_placeholder: 'Introduce el título de la tarea',
        tarefa_empresa: 'Empresa',
        tarefa_empresa_placeholder: 'Selecciona la empresa',
        estado1: 'Por Iniciar',
        estado2: 'En Ejecución',
        estado3: 'En Revisión',
        estado4: 'Completada',
        estado5: 'Cancelada',
        prioridade_normal: 'Normal',
        prioridade_urgente: 'Urgente',
        prioridade_critico: 'Crítico',
        tarefa_prioridade_placeholder: 'Prioridad de la tarea',
        departamento_responsavel: 'Departamento responsable',
        grupo_responsavel: 'Grupo responsable',
        tarefa_departamento_placeholder: 'Departamento relacionado',
        tarefa_respm: 'Responsables',
        tarefa_respm_placeholder: 'Responsables',
        description: 'Descripción',
        solucao: 'Solución',
        validar_tarefa: 'Validar Tarea',
        cancel: 'Cancelar', back: 'Voltar',
        delete: 'Borrar',
        save: 'Guardar',
        edit: 'Editar',
        edit_text: 'Editar texto',
        edit_confirm: 'Confirmar',
        edit_cancel: 'Cancelar',
        insert_title: 'Insertar título',
        insert_text: 'Insertar texto',
        insert_confirm: 'Confirmar',
        insert_error: 'Error al insertar',
        edit_error: 'Error al editar tarea',
        loading: 'Cargando',
        tarefa_data: 'Fecha de Inicio',
        data_inicio: 'Fecha de Inicio',
        data_limite: 'Fecha Límite',
        validar_sucesso: 'Validada',
        table_actions: 'Acciones',
        table_all: 'Todo',
        table_count: 'Cantidad',
        table_date: 'Fecha',
        table_empty: 'Sin resultados',
        table_parent: 'Padre',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Miniatura',
        table_title: 'Título',
        table_type: 'Tipo',



        /// VIEW ///
        titulo_tarefa: 'Título de la tarea',
        codigo_tarefa: 'Código de la tarea',
        tarefa_tempo_expiracao: 'Tiempo de expiración de la tarea',
        tarefa_data_solucao: 'Fecha de solución',
        exportar_relatorio: 'Exportar informe',
        imprimir_relatorio: 'Imprimir informe',
        back: 'Volver',
    },
    'fr':
    {
        ///LIST///
        tarefa_prioridade: 'Priorité',
        tarefa_estado: 'État',
        tarefa_departamento: 'Département',
        tarefa_resp: 'Responsables',
        concluida: 'Terminée',
        task_number: 'Nº',
        view: 'Voir',
        edit: 'Éditer',
        delete: 'Supprimer',
        tarefa: 'Tâche',
        home: 'Accueil',
        tarefa_list: 'Liste des tâches',
        tarefa_filtro_nao_concluidos: 'Filtrer Non Terminées',
        filtro_concluidos: 'Filtrer Terminées',
        tarefa_por_expirar: 'Filtrer Par Expiration',
        tarefa_expirados: 'Filtrer Expirées',
        add_new_tarefa: 'Nouvelle tâche',
        no_results: 'Aucun résultat',
        tarefa_monitor: 'Moniteur',
        delete_task: 'Supprimer tâche',
        delete_success: 'Supprimée avec succès',
        delete_error: 'Erreur lors de la suppression de la tâche',

        ////// REGIST ////
        insert_task: 'Insérer une nouvelle tâche',
        tarefa_data: 'Données de la tâche',
        tarefa_acao_placeholder: 'Entrez le titre de la tâche',
        tarefa_empresa: 'Entreprise',
        tarefa_empresa_placeholder: 'Choisissez une entreprise',
        estado1: 'À commencer',
        estado2: 'En cours',
        estado3: 'En révision',
        estado4: 'Terminée',
        estado5: 'Annulée',
        prioridade_normal: 'Normale',
        prioridade_urgente: 'Urgente',
        prioridade_critico: 'Critique',
        tarefa_prioridade_placeholder: 'Priorité de la tâche',
        departamento_responsavel: 'Département responsable',
        grupo_responsavel: 'Groupe responsable',
        tarefa_departamento_placeholder: 'Département concerné',
        tarefa_respm: 'Responsables',
        tarefa_respm_placeholder: 'Responsables',
        description: 'Description',
        solucao: 'Solution',
        validar_tarefa: 'Valider la tâche',
        cancel: 'Annuler',
        delete: 'Supprimer',
        save: 'Enregistrer',
        edit: 'Éditer',
        edit_text: 'Éditer le texte',
        edit_confirm: 'Confirmer',
        edit_cancel: 'Annuler',
        insert_title: 'Insérer un titre',
        insert_text: 'Insérer un texte',
        insert_confirm: 'Confirmer',
        insert_error: 'Erreur lors de l\'insertion',
        edit_error: 'Erreur lors de l\'édition de la tâche',
        loading: 'Chargement',
        tarefa_data: 'Date de début',
        data_inicio: 'Date de début',
        data_limite: 'Date limite',
        validar_sucesso: 'Validée',

        table_actions: 'Actions',
        table_all: 'Tout',
        table_count: 'Nombre',
        table_date: 'Date',
        table_empty: 'Aucun résultat',
        table_parent: 'Parent',
        table_rows_per_page: 'Enregistrements par page :',
        table_separator: 'de',
        table_state: 'État',
        table_thumbnail: 'Vignette',
        table_title: 'Titre',
        table_type: 'Type',

        /// VIEW ///
        titulo_tarefa: 'Titre de la tâche',
        codigo_tarefa: 'Code de la tâche',
        tarefa_tempo_expiracao: 'Temps d\'expiration de la tâche',
        tarefa_data_solucao: 'Date de résolution',
        exportar_relatorio: 'Exporter le rapport',
        imprimir_relatorio: 'Imprimer le rapport',
        back: 'Retour',
    }

}

module.exports = {
    language
};